import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const t = localStorage.getItem("du_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            const onAdmin = window.location.pathname.startsWith("/admin");
            if (onAdmin && window.location.pathname !== "/admin/login") {
                localStorage.removeItem("du_token");
                window.location.href = "/admin/login";
            }
        }
        return Promise.reject(err);
    }
);

export default api;

export const formatErr = (e) => {
    const d = e?.response?.data?.detail ?? e?.message;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
    return JSON.stringify(d);
};
